import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { dashboardCRUD } from "../../http";
import { yearEnd, yearStart } from "../../functions/dateHelpers";
import FilterDatePicker from "../../components/DatePicker/FilterDatePiecker";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const DddFullReport = () => {
    const start = yearStart();
    const end = yearEnd();

    const [query, setQuery] = useState({
        paging: { skip: 0 },
        filter: {
            researchEndDateTime: {
                operand1: start,
                operand2: end,
                operator: "between"
            }
        }
    });

    const [groupedData, setGroupedData] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchAsync = async () => {
        setLoading(true);
        const response = await dashboardCRUD.post('requestTarifications/quantity/indices/ddd', query);

        const grouped = {};

        response.forEach((item, index) => {
            const region = item.filialName || "Неизвестно";
            if (!grouped[region]) grouped[region] = [];

            grouped[region].push({
                index: grouped[region].length + 1,
                filial: region,
                nozology: item.service?.name || "",
                kind: item.service?.kind || "",
                method: item.service?.method || "",
                code: item.service?.code ||  "",
                volume: item.volume || 0,
                tourVolume: "",
                fact: item.volume || 0,
                points: "",
                equipment: "",
                chemical: "",
                unit: "",
                amount: ""
            });
        });

        setGroupedData(grouped);
        setLoading(false);
    };

    const getRegionTotal = (rows, field) =>
        rows.reduce((acc, row) => acc + (row[field] || 0), 0).toFixed(2);

    const getGlobalTotal = (field) => {
        return Object.values(groupedData)
            .flat()
            .reduce((acc, row) => acc + (row[field] || 0), 0)
            .toFixed(2);
    };

    return (
        <DashboardLayout>
            <Stack direction="row" alignItems="center" justifyContent="normal">
                <label style={{ minWidth: "360px" }}>
                    Природные очаги за ПЕРИОД
                </label>
                <FilterDatePicker label="от" value={query.filter.researchEndDateTime.operand1} handleFunction={(value) => {
                    if (value) {
                        query.filter.researchEndDateTime.operand1 = value;
                        setQuery({ ...query });
                    }
                }} style={{ width: "250px" }} />
                <FilterDatePicker label="до" value={query.filter.researchEndDateTime.operand2} handleFunction={(value) => {
                    if (value) {
                        query.filter.researchEndDateTime.operand2 = value;
                        setQuery({ ...query });
                    }
                }} style={{ width: "250px", marginLeft: "10px" }} />
                <LoadingButton loading={loading} style={{ marginLeft: "10px" }} onClick={fetchAsync}>
                    Сформировать
                </LoadingButton>
            </Stack>

            <div style={{ height: "10px" }}></div>


<table style={{ width: "100%" }} className="ant-table">
                <thead className="ant-table-thead">
                    <tr>
                        <th>№</th>
                        <th>Филиал</th>
                        <th>Нозология</th>
                        <th>Вид обработки</th>
                        <th>Способ обработки</th>
                        <th>Код услуги</th>
                        <th>Объем, га</th>
                        <th>Объем одного тура, га</th>
                        <th>Факт, га</th>
                        <th>Пункты</th>
                        <th>Оборудование</th>
                        <th>Дез. средство</th>
                        <th>Ед. изм.</th>
                        <th>Кол-во</th>
                    </tr>
                </thead>
                <tbody className="ant-table-tbody">
                    {Object.entries(groupedData).map(([region, rows], regionIndex) => (
                        <React.Fragment key={regionIndex}>
                            {rows.map((row, i) => (
                                <tr key={i} className="ant-table-row">
                                    <td className="ant-table-cell">{row.index}</td>
                                    <td className="ant-table-cell">{row.filial}</td>
                                    <td className="ant-table-cell">{row.nozology}</td>
                                    <td className="ant-table-cell">{row.kind}</td>
                                    <td className="ant-table-cell">{row.method}</td>
                                    <td className="ant-table-cell">{row.code}</td>
                                    <td className="ant-table-cell">{row.volume}</td>
                                    <td className="ant-table-cell">{row.tourVolume}</td>
                                    <td className="ant-table-cell">{row.fact}</td>
                                    <td className="ant-table-cell">{row.points}</td>
                                    <td className="ant-table-cell">{row.equipment}</td>
                                    <td className="ant-table-cell">{row.chemical}</td>
                                    <td className="ant-table-cell">{row.unit}</td>
                                    <td className="ant-table-cell">{row.amount}</td>
                                </tr>
                            ))}
                            <tr className="ant-table-row" style={{ backgroundColor: "#d9f7be" }}>
                                <td></td>
                                <td colSpan={5}>Всего по филиалу:</td>
                                <td>{getRegionTotal(rows, 'volume')}</td>
                                <td></td>
                                <td>{getRegionTotal(rows, 'fact')}</td>
                                <td colSpan={5}></td>
                            </tr>
                        </React.Fragment>
                    ))}
                    {Object.keys(groupedData).length > 0 && (
                        <tr className="ant-table-row" style={{ backgroundColor: "#3cb37188" }}>
                            <td></td>
                            <td colSpan={5}><strong>Общий итог:</strong></td>
                            <td>{getGlobalTotal('volume')}</td>
                            <td></td>
                            <td>{getGlobalTotal('fact')}</td>
                            <td colSpan={5}></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </DashboardLayout>
    );
};

export default DddFullReport;